// The calorie «estimate» tag. Since #290 a workout's calories have ONE source:
// the estimate Metria computes. Health Connect calories are no longer read,
// and the ones already stored are no longer shown, so there is no second
// figure to pick between and no source to name.
//
// The estimate is always labelled as one, next to the value: a calorie count
// is never presented as a measurement. A low-confidence estimate (any MET
// route, or Keytel on a non-cardio bout) says so more plainly.

import type { CalorieConfidence } from "./calorieEstimate.js";

/** The i18n key of the «estimate» tag shown beside a calorie value. One place,
 *  read by the on-screen block and the share card. */
export const estimateLabelKey = (confidence: CalorieConfidence): string =>
  confidence === "low"
    ? "mobile.energySource.estimateRough"
    : "mobile.energySource.estimate";
